import script from "./awayManagement.vue?vue&type=script&lang=ts&setup=true"
export * from "./awayManagement.vue?vue&type=script&lang=ts&setup=true"

import "./awayManagement.vue?vue&type=style&index=0&id=f57a62c2&lang=less&scoped=true"

import exportComponent from "D:\\projectLy\\2025伟本\\weben-les-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f57a62c2"]])

export default __exports__